import { render, staticRenderFns } from "./RegisteredExams.vue?vue&type=template&id=695253ad"
import script from "./RegisteredExams.vue?vue&type=script&lang=js"
export * from "./RegisteredExams.vue?vue&type=script&lang=js"
import style0 from "./RegisteredExams.vue?vue&type=style&index=0&id=695253ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports